import "./ItalianLeftList.module.css";
import Header from "@/reusable_sections/Header";
import CandidatiLista2 from "./sections/CandidatiLista2";
import Footer from "@/reusable_sections/Footer";
export default function ItalianLeftListPage() {
  return <div className='min-h-screen flex flex-col'>
      <Header />
      <CandidatiLista2 />
      <Footer />
    </div>;
}